import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import WhatsAppButton from '../WhatsAppButton';

const Layout = ({ children, showFooter = true }) => {
  return (
    <div className="flex min-h-screen flex-col bg-black" data-testid="layout-upim">
      <Navbar />
      <main className="flex-1 pt-6 lg:pt-10">
        {children}
      </main>
      {showFooter && <Footer />}
      <WhatsAppButton />
    </div>
  );
};

export default Layout;
